export default "__VITE_ASSET__CnEI8BjS__"